import type { BasicSuccessResponse, HTTPFunctions, NodePosition } from '../types';

const touchpoints = ({ put }: HTTPFunctions) => ({
  putNodesPosition: (data: NodePosition[]) => put<BasicSuccessResponse>('/node/position', data),
});

export default touchpoints;
